/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-10-27 16:30:40
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-18 12:06:57
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\BasePriceSelect\CustomPriceModal.tsx
 * @Description: 自定义价格弹窗组件
 */
import React, { useMemo } from 'react'
import { Modal, Form } from '@bedrock/components'
import { useMemoizedFn } from 'ahooks'
import { FormItemRow } from '#components/SForm/createFormItemRow'
import { type BasePriceConfigDto } from '#services/api'
import { useDemandOptions } from "#features/useDemandOptions";

type BasePrice = BasePriceConfigDto

/**
 * 自定义价格弹窗组件
 * @description 用于自定义设置基准价格，包括价格类型和金额
 */
const CustomPriceModal = (props: {
  value: BasePrice
  onClose?: () => void
  onChange?: (basePrice: BasePrice) => void
}) => {
  const { value, onClose, onChange, ...rest } = props
  const [form] = Form.useForm()
  const { optionsListMap } = useDemandOptions({
    keys: ['demand_source_base_price_custom_type'],
    params: {
      group_type: undefined,
    },
  })
  /**
   * 价格类型选项
   * @description 定义可选的价格类型（目前仅支持市场价）
   */
  const basePriceTypeOptions = useMemo(() => {
    if (!optionsListMap['demand_source_base_price_custom_type']) {
      return [{
        name: value?.base_price_name,
        value: value?.base_price_type,
      }]
    }
    return optionsListMap['demand_source_base_price_custom_type']?.map(item => ({
      name: item.name,
      value: item.value,
    }))
  }, [optionsListMap, value])

  /**
   * 确认保存自定义价格
   * @description 验证表单后，构造基准价对象并回调给父组件
   */
  const handleOk = useMemoizedFn(() => {
    form.validateFields().then(values => {
      // 构造自定义价格对象
      const basePrice = {
        source_name: '自定义价格',
        source_type: 'CUSTOM_PRICE',
        base_price_name: basePriceTypeOptions.find(item => item.value === values.base_price_type)?.name,
        base_price_type: values.base_price_type,
        base_price: values.base_price?.value,
        base_price_currency: values.base_price?.currency,
      }
      onChange?.(basePrice)
      onClose?.()
    })
  })

  /**
   * 表单初始值
   * @description 如果当前值是自定义价格，则填充表单；否则为空
   */
  const initialValues = useMemo(() => {
    if(value?.source_type != 'CUSTOM_PRICE') {
      return {
        base_price: {
          currency: 'rmb',
        }
      };
    }
    return {
      base_price_type: value?.base_price_type,
      base_price: {
        value: value?.base_price,
        currency: value?.base_price_currency || 'rmb',
      }
    }
  }, [value])

  return (
    <>
      <Modal title="自定义基准价" width={480} height={600} {...rest} onOk={handleOk} onClose={onClose} >
        <div>
          <Form form={form} layout="vertical" initialValues={initialValues}>
            <FormItemRow
              itemCols={[
                {
                  formItemKey: 'base_price_type',
                  label: '类型',
                  required: true,
                  componentClass: 'select',
                  col: 24,
                  elementProps: {
                    options: basePriceTypeOptions,
                  },
                },
                {
                  formItemKey: 'base_price',
                  label: '价格',
                  required: true,
                  componentClass: 'currencyType',
                  col: 24,
                  elementProps: {
                    inputStyle: {
                      width: '100%',
                    },
                  },
                },
            ]} />
          </Form>
        </div>
      </Modal>
    </>
  )
}

export default CustomPriceModal

